import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { prjDeptHeaderTyps } from '../../utils/forecastStaticData';
import { getNumberComma } from '../../utils/numberUtils';

const MaintanceDeptStaticCell = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      return prjDeptHeaderTyps.map((type, tIndex) => {
        let key = `${fIndex}_${tIndex}`;

        let value = _.has(data, `${field.val}.${type.id}`)
          ? data[field.val][type.id]
          : '-';
        let formatValue = type.id !== 'profit' ? getNumberComma(value) : value;

        return (
          <TableCell
            sx={{ width: '100px', paddingLeft: 0 }}
            align="right"
            key={key}
          >
            {formatValue}
          </TableCell>
        );
      });
    })
  );
};

export default MaintanceDeptStaticCell;
